export default "__VITE_ASSET__5c9b4a09__"